<script lang="ts">
	import * as m from '$lib/paraglide/messages';
	import { localizeHref } from '$lib/paraglide/runtime';

	// utm_content = pageId — atrybucja per strona wiki w PostHog/GA.
	let { pageId }: { pageId: string } = $props();

	const href = $derived(
		localizeHref(`/auth/login?utm_source=wiki&utm_medium=cta&utm_content=${pageId}`)
	);
</script>

<aside class="wiki-cta">
	<div class="wiki-cta-copy">
		<p class="wiki-cta-title">{m.wiki_cta_title()}</p>
		<p class="wiki-cta-body">{m.wiki_cta_body()}</p>
	</div>
	<a class="btn btn-primary" {href} data-sveltekit-reload>
		{m.wiki_cta_button()} <span class="arrow">→</span>
	</a>
</aside>

<style>
	.wiki-cta {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 1.5rem;
		flex-wrap: wrap;
		border: 1px solid var(--v3-border);
		background: var(--v3-surface);
		border-radius: 1rem;
		padding: 1.5rem;
		margin-top: 3rem;
	}
	.wiki-cta-copy {
		min-width: 0;
	}
	.wiki-cta-title {
		font-weight: 700;
		letter-spacing: -0.01em;
		color: var(--v3-text);
		margin: 0 0 0.25rem;
	}
	.wiki-cta-body {
		color: var(--v3-muted);
		font-size: 0.9rem;
		margin: 0;
		max-width: 48ch;
	}
</style>
